module.exports = __webpack_public_path__ + "img/review-pin.e8fba6fd.svg";